<template>
  <v-container>
    <vue-headful title="Apologies!" />
    <v-flex xs12>
      <div class="error-image">
        <img class="center" src="../../assets/errorHouse.png" alt="Upside Down house" />
        <h1 class="error-title">Something's not right</h1>
      </div>
      <div class="caution-img">
        <img class="center" src="../../assets/cautionIcon.png" alt="Caution Icon" />
      </div>
      <h2>Sorry! Looks like this page was installed incorrectly.</h2>
      <h3>
        Need some help? Email us at <a href="mailto:support@homegauge.com">support@homegauge.com</a>
        or call <a href="tel:8282542030">(828)254-2030</a>.
      </h3>
      <h3>If you email us, please include the details below.</h3>
      <div class="error-text">
          <p>
            <span class="error-section">Calling function</span>
            <pre>{{error.callingFunction}}</pre>
          </p>
          <p>
            <span class="error-section">Date</span>
            <pre>{{currentTime}}</pre>
          </p>
          <p>
            <span class="error-section">Data</span>
            <pre>{{error.data}}</pre>
          </p>
          <p>
            <span class="error-section">Error</span>
            <pre>{{error.error}}</pre>
          </p>
      </div>
    </v-flex>
  </v-container>
</template>

<script>
import Moment from 'moment';
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState('Http', {
      error: state => state.error,
    }),
    currentTime() {
      return Moment().format('LLL');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/vars/theme';
@import '../../styles/vars/typography';

img {
  max-height: 100%;
  max-width: 100%;
}

.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.error {
  &-image {
    margin-top: 30px;
  }

  &-section {
    display: block;
    font-size: 1.25rem;
    font-weight: $typography-weight-bold
  }

  &-text {
    padding: 20px 100px 50px 100px
  }

  &-title {
    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
    text-transform: uppercase;
  }
}

.caution-img {
  margin-bottom: 20px;
}

h1 {
  color: $theme-color-white;
  font-size: 3em;
  font-weight: bold;
  position: relative;
  text-align: center;
  top: -100px;
}

h2 {
  color: #4c0082;
  text-align: center;
  font-size: 2.143rem;
  font-weight: $typography-weight-bold;
}

h3 {
  font-size: 1.214rem;
  padding-bottom: 50px;
  padding-top: 15px;
  text-align: center;
}

label {
  font-weight: $typography-weight-bold;
}

pre {
  white-space: pre-wrap;
  word-wrap: break-word;
}

@media all and (max-width: 655px) {
  h1 {
    position: relative;
    top: -125px;
  }

  .error-image {
    margin: 0;
  }

  .caution-img {
    margin: 0;
    position: relative;
    top: -50px;
  }
}
</style>
